import { useEffect, useState } from 'react';
import { Clock, Eye, ChevronUp, ChevronDown } from 'react-feather';
import { useRemote, useStorage } from '../../../Utils/Utils';
import { useHistory } from 'react-router-dom';
import { format, parseISO, sub } from 'date-fns';
import Table from '../../../components/Table/Table';
import IconCounter from '../../../components/IconCounter';
import ProfileImage from '../../../components/ProfileImage';
import TickerSectorItem from '../../../components/TickerSectorItem';
import Tooltip from '../../../components/popups/Tooltip';
import TruncatedString from '../../Shared/TruncatedString'
import AnalyticsHeader from './AnalyticsHeader'
import Divider from '../../../components/Divider';
import "./TopResearchTable.scss";


const TopResearchTable = ({ dateRanges }) => {
	const remote = useRemote();
	const storage = useStorage();
	const history = useHistory()
	const [allData, setAllData] = useState([])
	const [researchData, setResearchData] = useState([])
	const [allTickers, setAllTickers] = useState([])
	const [allGroups, setAllGrpups] = useState([])
	const [researchDateRange, setResearchDateRange] = useState(dateRanges[0]);
	const [sortingColumn, setSortingColumn] = useState({ column: "PortalViews", ascending: false })

	const end = format(new Date(), 'yyyy-MM-dd')

	useEffect(() => {
		storage.getOrFetch(`/crm/tickers`).then(setAllTickers)
		storage.getOrFetch(`/crm/groupings/${1}`).then((fetchedGrouping) => {
			setAllGrpups(fetchedGrouping ? fetchedGrouping.groups : [])
		}).catch(() => setAllGrpups([]))
	}, [])

	useEffect(() => {
		let time = { months: 6 }

		if (researchDateRange) {
			time = researchDateRange
		}
		let date = typeof researchDateRange === "string" ? researchDateRange : format(sub(new Date(), time), "yyyy-MM-dd")
		remote.get(`/analytics/aggregates/documents?from=${date}&to=${end}`).then((stats) => {
			setAllData(stats)
			// const dummyData = [
			// 	{ uniqueViews: 30, publishedBy: 'Leo Rey', title: 'Queso Feliz', publishedDate: '2025-01-23', ticker: 'MEL.NZ', count: 4, minutes: 80 },
			// 	{ uniqueViews: 10, publishedBy: 'Sonia Campellan', title: 'Viva si', publishedDate: '2024-08-15', ticker: 'ERD.NZ', count: 6, minutes: 120 },
			// 	{ uniqueViews: 35, publishedBy: 'Jairo Sequerira', title: 'Oseano profundo', publishedDate: '2025-01-04', ticker: 'MCY.NZ', count: 4, minutes: 66 },
			// 	{ uniqueViews: 14, publishedBy: 'Sonia Campellan', title: 'Launa y todo sereno', publishedDate: '2024-03-10', ticker: 'EBO.NZ', count: 6, minutes: 79 },
			// 	{ uniqueViews: 20, publishedBy: 'Jairo Sequerira', title: 'La vida se abre camino', publishedDate: '2025-09-15', ticker: 'Utilities', count: 4, minutes: 92 },
			// 	{ uniqueViews: 19, publishedBy: 'Miriam Parra', title: 'Geton feo', publishedDate: '2024-11-19', ticker: 'AIA.NZ', count: 6, minutes: 46 },
			// 	{ uniqueViews: 7, publishedBy: 'Leo Rey', title: 'Rebasalo hermano', publishedDate: '2025-02-21', ticker: 'SPK.NZ', count: 4, minutes: 111 },
			// 	{ uniqueViews: 4, publishedBy: 'Miriam Parra', title: 'Jamas voy a decir eso', publishedDate: '2024-10-24', ticker: 'IFT.NZ', count: 6, minutes: 108 },
			// ]
			// setAllData(dummyData)
		});
	}, [researchDateRange]);

	useEffect(() => {
		sortTable(sortingColumn.column, 'descending')
	}, [allData])

	function sortTable(column, string) {
		let tableData = allData
		const ascending = sortingColumn.column === column ? string && string === 'descending' ? false : !sortingColumn.ascending : true
		switch (column) {
			case "Minutes":
				tableData.sort((a, b) => ascending ? a.minutes - b.minutes : b.minutes - a.minutes)
				break;
			case "PortalViews":
				tableData.sort((a, b) => ascending ? a.uniqueViews - b.uniqueViews : b.uniqueViews - a.uniqueViews)
				break;
			default:
				break;
		}
		const topFive = tableData.slice(0, 5)
		setSortingColumn({ column: column, ascending: ascending })
		setResearchData(topFive);
	}

	return <>
		<div className='db-table-header'>
			<AnalyticsHeader dateRanges={dateRanges} timeFrame={researchDateRange} setTimeFrame={setResearchDateRange}>Research - Most Viewed</AnalyticsHeader>			<Divider vertical style={{ marginBottom: '1.5rem', height: 16 }} />
			<div className='db-table-header-sorting-icons'>
				<div className='sorting-header' onClick={() => sortTable("Minutes")}>
					<Clock className={sortingColumn && sortingColumn.column === "Minutes" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={16} />
					{sortingColumn && sortingColumn.column === "Minutes" && sortingColumn.ascending === true ?
						<ChevronUp className="colour-text-primary" size={12} /> :
						<ChevronDown className={sortingColumn && sortingColumn.column === "Minutes" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
					}
				</div>
				<div className='sorting-header' onClick={() => sortTable("PortalViews")}>
					<Eye className={sortingColumn && sortingColumn.column === "PortalViews" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={16} />
					{sortingColumn && sortingColumn.column === "PortalViews" && sortingColumn.ascending === true ?
						<ChevronUp className="colour-text-primary" size={12} /> :
						<ChevronDown className={sortingColumn && sortingColumn.column === "PortalViews" ? "colour-text-primary" : "colour-text-neutral-dark-30"} size={12} />
					}
				</div>
			</div>
		</div>
		<ResearchTable data={researchData} changeRoute={(url) => history.push(url)} allTickers={allTickers} allGroups={allGroups} />
	</>
}

export default TopResearchTable;

const getInitials = (name) => {
	const arr = name && name.split(" ") || []
	let initials = arr.map(word => word.charAt(0))
	return initials.join("")
}

const ResearchTable = ({ data, changeRoute, allTickers, allGroups }) => {
	const colWidths = ["20%", "110px", "auto", "220px"];

	function handleOnClick(research, goToResearch) {
		if (allTickers && allTickers.length > 0 && research.ticker?.includes(".")) {
			const ticker = allTickers.find(t => t.ric && t.ric === research.ticker)
			return ticker && goToResearch ? changeRoute(`/analytics/tickers/${ticker.id}/research/${research.documentId}`) : ticker ? changeRoute(`/analytics/tickers/${ticker.id}`) : null
		} else if (allGroups && allGroups.length > 0 && !research.ticker?.includes(".")) {
			const group = allGroups.find(g => g.groupName === research.ticker)
			return group && goToResearch ? changeRoute(`/analytics/group/${group.id}/research/${research.documentId}`) : group ? changeRoute(`/analytics/group/${group.id}`) : null

		} else return null
	}

	function getImage(research) {
		if (allTickers && allTickers.length > 0 && research.ticker?.includes(".")) {
			const ticker = allTickers.find(t => t.ric && t.ric === research.ticker)
			return ticker ? `/api/public/images/ticker/${ticker.id}.png` : null
		} else if (allGroups && allGroups.length > 0 && !research.ticker?.includes(".")) {
			const group = allGroups.find(g => g.groupName === research.ticker)
			return group ? `/api/public/images/group/${group.id}.png` : null
		} else return null
	}

	const dataMap = () => data && data.map((research, idx) => {
		const averageSession = research.minutes / research.count
		const minutes = Math.floor(averageSession)
		const seconds = Math.round((averageSession - minutes) * 60)
		const readableFormat = `${minutes > 0 ? minutes + 'm ' : ''}${seconds}s`

		return (
			<tr key={idx} className="cursor-pointer">
				<td>
					<TickerSectorItem size="m" label={research.ticker} image={getImage(research)} onClick={() => handleOnClick(research)} />
				</td>
				<td onClick={() => handleOnClick(research, true)}>{format(parseISO(research.publishedDate), 'dd/MM/yyyy')}</td>
				<td className="truncate" onClick={() => handleOnClick(research, true)}><TruncatedString string={research.title} /></td>
				<td className="table-action-icons transition-fade-in-slow" onClick={() => handleOnClick(research, true)} style={{ marginRight: 0 }}>
					<div className='top-research-icons'>
						<Tooltip label={research.publishedBy}><ProfileImage initials={getInitials(research.publishedBy)} size={24} /></Tooltip>
						<IconCounter icon={<Clock />} tooltip="Average Session" dataAvailable count={readableFormat} />
						<IconCounter icon={<Eye />} tooltip="Views" dataAvailable count={research.uniqueViews} />
					</div>
				</td>
			</tr>
		);
	});

	return (
		<Table suggestionMessage space='l' wrapperStyle={{ width: "100%" }} tableStyle={{ minWidth: 600 }} rowSize="s" colWidths={colWidths} dataMap={dataMap()} />
	);
}